import { fetchQueryApi } from 'api/fetchApi'
import { paths } from 'api/generated/seo'
import { NodeHeaders } from 'api/NodeHeaders'

type SeoSnippet = paths['/seo/snippet']
type SeoSnippetMethod = SeoSnippet['get']
export type SeoSnippetQuery = SeoSnippetMethod['parameters']['query']
type SeoSnippetResponse = SeoSnippetMethod['responses']['200']['schema']

export const fetchSeoSnippetApi = (
  locationId: number,
  locationType: string,
  lookFor: SeoSnippetQuery['lookFor'],
  headers?: NodeHeaders
) =>
  fetchQueryApi<SeoSnippetResponse, SeoSnippetQuery>(
    '/seo/snippet',
    {
      'seoLocationId[type]': locationType,
      'seoLocationId[locationId]': locationId,
      lookFor,
    },
    {
      headers,
    }
  )

type SeoAdsLink = paths['/seo/ads-links']
type SeoAdsLinkMethod = SeoAdsLink['get']
export type SeoAdsLinkQuery = SeoAdsLinkMethod['parameters']['query']
type SeoAdsLinkResponse = SeoAdsLinkMethod['responses']['200']['schema']

export const fetchAdsLinksApi = (
  locationId: number,
  locationType: string,
  lookFor: SeoAdsLinkQuery['lookFor'],
  headers?: NodeHeaders
) =>
  fetchQueryApi<SeoAdsLinkResponse, SeoAdsLinkQuery>(
    '/seo/ads-links',
    {
      'seoLocationId[type]': locationType,
      'seoLocationId[locationId]': locationId,
      lookFor,
    },
    {
      headers,
    }
  )

type SeoResolveLocation = paths['/seo/resolve/location']
type SeoResolveLocationMethod = SeoResolveLocation['get']
export type SeoResolveLocationQuery =
  SeoResolveLocationMethod['parameters']['query']
type SeoResolveLocationResponse =
  SeoResolveLocationMethod['responses']['200']['schema']

export const resolveSeoLocationApi = (
  locationId: number,
  locationType: string,
  lookFor: SeoResolveLocationQuery['lookFor'],
  headers?: NodeHeaders
) =>
  fetchQueryApi<SeoResolveLocationResponse, SeoResolveLocationQuery>(
    '/seo/resolve/location',
    {
      'seoLocationId[locationId]': locationId,
      'seoLocationId[type]': locationType,
      lookFor,
    },
    {
      headers,
    }
  )

type SeoTopLocationsLinks = paths['/seo/top-locations-links']
type SeoTopLocationsLinksMethod = SeoTopLocationsLinks['get']
export type SeoTopLocationsLinksQuery =
  SeoTopLocationsLinksMethod['parameters']['query']
type SeoTopLocationsLinksResponse =
  SeoTopLocationsLinksMethod['responses']['200']['schema']

export const fetchTopLocationLinksApi = (
  locationId: number,
  locationType: string,
  lookFor: SeoTopLocationsLinksQuery['lookFor'],
  limit: number,
  headers?: NodeHeaders
) =>
  fetchQueryApi<SeoTopLocationsLinksResponse, SeoTopLocationsLinksQuery>(
    '/seo/top-locations-links',
    {
      'seoLocationId[locationId]': locationId,
      'seoLocationId[type]': locationType,
      lookFor,
      limit,
    },
    {
      headers,
    }
  )
